import { connect } from 'react-redux';

import { getItems, getCategories } from 'routes/admin/actions';
import { getCategorySelection, setCategorySelection, submitSelection } from 'client/actions';
import CategoryContainer from './CategoryContainer';

const mapState = state => ({
	categories: state.categories.data,
	items: state.items.data,
	isFetching: state.items.fetching,
	selection: state.selection,
});

const mapDispatch = {
	getItems,
	getCategories,
	getCategorySelection,
	setCategorySelection,
	submitSelection,
};

export default connect(mapState, mapDispatch)(CategoryContainer);
